export default __webpack_public_path__ + "static/media/stephanie_garcia.a88b709c.png";